export enum MissionTypeEnum
{
    Game = 1,
    Exam = 2,
    TrainerCommentView = 3,
    VideosView = 4
}